export default "__VITE_ASSET__C$PGdNvC__"